<template>
	<div class="MoreNews">
		<div class="more">
			<p>更多资料</p>
			<router-link to="/index" target="index">查看更多</router-link>
		</div>
		<!-- pc -->
		<ul v-if="islayout">
			<li v-for="(item,index) in MoreNewsList" :key="index">
				<router-link :to="{path:'/bookDetail', query:{InformationId:item.id}}" target="_blank">
					<div class="imgWrap"><img :src="item.imagePath" alt="" /></div>
					<div class="intrWrap">
						<h5>{{item.title}}</h5>
						<p>{{item.abstract}}</p>
					</div>
				</router-link>
			</li>
		</ul>
		<!-- mobile -->
		<ul v-else>
			<li v-for="(item,index) in MoreNewsList" :key="index">
				<router-link :to="{path:'/bookDetail', query:{InformationId:item.id}}">
					<div class="imgWrap"><img :src="item.imagePath" alt="" /></div>
					<div class="intrWrap">
						<h5>{{item.title}}</h5>
						<p>{{item.abstract}}</p>
					</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
export default{
	data(){
		return{
			MoreNewsList:[],  // 更多情报列表
			islayout:true,  // 布局
		}
	},
	mounted() {
		// 判断加载哪个dom
		let wid = window.innerWidth;
		if(wid>=320&&wid<=1024){
			this.islayout = false;
		}
		this.GetMoreNews();
	},
	methods:{
		// 更多情报
		GetMoreNews(){
			let params = '?PageNumber=1&PageSize=3&IsRecommend=true&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc';
			this.$fetch('/api/information'+params)
			.then((res)=>{
				this.MoreNewsList = res.data;
			}).catch((err)=>{
				throw err;
			});
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	.MoreNews{
		display: none;
	}
}
@media screen and (min-width: 1029px) {
	.MoreNews{
		width: 100%;
		padding: 0 37px;
		box-sizing: border-box;
		overflow: hidden;
	}
	.MoreNews .more{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.MoreNews .more>p{
		font-size: 16px;
		color: #333333;
		line-height: 24px;
	}
	.MoreNews .more>a{
		font-size: 14px;
		color: #333333;
		line-height: 24px;
	}
	/* 列表 */
	.MoreNews ul{
		width: 100%;
		margin: 16px 0 40px;
		display: flex;
		text-align: left;
	}
	.MoreNews li {
		margin-right: 20px;
	}
	.MoreNews li a{
		width: 362px;
		height: 168px;
		background: #FFFFFF;
		box-shadow: 0 2px 16px 0 rgba(0,0,0,0.06);
		border-radius: 4px;
		display: flex;
		padding: 16px;
	}
	.MoreNews .imgWrap{
		margin-right: 16px;
	}
	.MoreNews li a img{
		width: 102px;
		height: 136px;
	}
	.intrWrap {
		overflow: hidden;
	}
	.intrWrap h5{
		font-size: 14px;
		color: #333333;
		letter-spacing: 0;
		line-height: 22px;
		margin-bottom: 8px;
	}
	.intrWrap p{
		height: 110px;
		font-size: 14px;
		color: #666666;
		letter-spacing: 0;
		line-height: 22px;
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		overflow: hidden;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/MoreNews.vue